<template>
  <div class="row m-0 v-clean mt-2">
    <div class="col-md-12 pt-0 pb-0">
      <label-required-field class="m-0" label="QUANTIDADE" />
      <v-text-field-default type="number" label="" v-model="quantity" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <label-required-field class="m-0" label="DATA DO SERVIÇO" />
      <v-text-field-default type="date" label="" v-model="date" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn-save
        :disabled="loading"
        :loading="loading"
        text="SALVAR"
        @click="execute"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../../Components/VBtnSave.vue";

import LabelRequiredField from "../../../../Components/LabelRequiredField.vue";

import VTextFieldDefault from "../../../../Components/VTextFieldDefault.vue";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    VBtnSave,
    LabelRequiredField,
    VTextFieldDefault,
  },

  props: {
    service: Object,
  },

  data() {
    return {
      quantity: 1,
      date: moment().format("YYYY-MM-DD"),

      loading: false,

      errors: [],
    };
  },

  created() {
    let { date, quantity } = this.service;
    this.date = moment(date).format("YYYY-MM-DD");
    this.quantity = quantity;
  },

  methods: {
    moment,

    async execute() {
      try {
        this.loading = true;

        const {
          service: { id },
          quantity,
          date,
        } = this;

        let params = { id, quantity, date };

        const response = await api.patch("/rest-home/resident/service", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("edit");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
